unit UFakParaModel;

interface

uses
  UEssentialHelper, Js, WebLib.Controls, WebLib.Storage;

type
  TFakParaModel = class
  private
    FExtern: Boolean;
    FSource: string;
    FAppVerw: Boolean;
    FMengenVerw: Boolean;
    FTaetVerw: Boolean;
    FOnPropertyChanged: TCallback;
    FOnError: TErrorEvent;
    procedure PropertyChanged;
    procedure SetOnPropertyChanged(const Value: TCallback);
    procedure SetOnError(const Value: TErrorEvent);
  public
    constructor Create;
    function ToJson: string;
    procedure ClearValues;
    procedure DoError(AMsg: string);
    procedure Get(url: string);
    procedure SetValues(json: string); overload;
    procedure SetValues(obj: TJsObject); overload;
    property Extern: Boolean read FExtern;
    property Source: string read FSource;
    property AppVerw: Boolean read FAppVerw;
    property MengenVerw: Boolean read FMengenVerw;
    property TaetVerw: Boolean read FTaetVerw;
    property OnPropertyChanged: TCallback read FOnPropertyChanged
      write SetOnPropertyChanged;
    property OnError: TErrorEvent read FOnError write SetOnError;
  end;

implementation

uses
  WebLib.json, WebLib.REST;

{ TFakParaModel }

procedure TFakParaModel.ClearValues;
begin
  Self.FExtern := false;
  Self.FSource := '';
  Self.FAppVerw := false;
  Self.FMengenVerw := false;
  Self.FTaetVerw := false;
end;

constructor TFakParaModel.Create;
begin
  Self.ClearValues;
end;

procedure TFakParaModel.DoError(AMsg: string);
begin
  if Assigned(Self.OnError) then
    Self.OnError(Self, AMsg);
end;

procedure TFakParaModel.Get(url: string);
var
  client: TRestClient;
  cmd: string;
  procedure Response(sender: TObject; aResponse: string);
  var
    jso: TJsObject;
  begin
    if aResponse <> '' then
      TLocalStorage.SetValue(cmd, aResponse)
    else
      aResponse := TLocalStorage.GetValue(cmd);
    if aResponse <> '' then
    begin
      jso := TJsJson.parseObject(aResponse);
      if jso['value'] <> nil then
        Self.SetValues(string(jso['value']));
      Self.PropertyChanged;
    end
    else
      Self.DoError('Verbindungsfehler: TFakParaModel.Get');
  end;

  procedure ErrorHandler(sender: TObject; ARequest: TJSXMLHttpRequestRecord;
    Event: TJSEventRecord; var Handled: Boolean);
  begin
    Handled := true;
    Response(sender, '');
  end;

begin
  client := TRestClient.Create(nil);
  client.OnResponse := Response;
  client.OnError := ErrorHandler;
  cmd := url + '/ConfigService/GetFakParaModel';
  client.HttpsPost(url + '/ConfigService/GetFakParaModel', 'application/json');
end;

procedure TFakParaModel.PropertyChanged;
begin
  if Assigned(Self.OnPropertyChanged) then
    Self.OnPropertyChanged(Self);
end;

procedure TFakParaModel.SetOnError(const Value: TErrorEvent);
begin
  FOnError := Value;
end;

procedure TFakParaModel.SetOnPropertyChanged(const Value: TCallback);
begin
  FOnPropertyChanged := Value;
end;

procedure TFakParaModel.SetValues(obj: TJsObject);
begin
  Self.ClearValues;
  if obj['Extern'] <> nil then
    Self.FExtern := StrToBoolean(string(obj['Extern']));
  if obj['Source'] <> nil then
    Self.FSource := string(obj['Source']);
  if obj['AppVerw'] <> nil then
    Self.FAppVerw := StrToBoolean(string(obj['AppVerw']));
  if obj['MengenVerw'] <> nil then
    Self.FMengenVerw := StrToBoolean(string(obj['MengenVerw']));
  if obj['TaetVerw'] <> nil then
    Self.FTaetVerw := StrToBoolean(string(obj['TaetVerw']));
end;

procedure TFakParaModel.SetValues(json: string);
var
  obj: TJsObject;
begin
  obj := TJsJson.parseObject(json);
  Self.SetValues(obj);
end;

function TFakParaModel.ToJson: string;
var
  obj: TJsonObject;
begin
  obj := TJsonObject.Create;
  obj.AddPair('Extern', BooleanToStr(Self.Extern));
  obj.AddPair('Source', Self.Source);
  obj.AddPair('AppVerw', BooleanToStr(Self.AppVerw));
  obj.AddPair('MengenVerw', BooleanToStr(Self.MengenVerw));
  obj.AddPair('TaetVerw', BooleanToStr(Self.TaetVerw));
  Result := obj.ToString;
  obj.Free;
end;

end.
